import React, { useEffect, useState } from 'react'
import { seedBrowserDatabase, needsSeeding } from '../../db/browser-seed.js'

interface DatabaseInitProps {
  children: React.ReactNode
}

export const DatabaseInit: React.FC<DatabaseInitProps> = ({ children }) => {
  const [isInitializing, setIsInitializing] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const initializeDatabase = async () => {
      try {
        console.log('🔍 Checking if database needs seeding...')

        // Wait for database to be ready
        await new Promise(resolve => setTimeout(resolve, 500))

        const shouldSeed = await needsSeeding()

        if (shouldSeed) {
          console.log('🌱 Database needs seeding, starting...')
          await seedBrowserDatabase()
          console.log('✅ Database seeded successfully!')
        } else {
          console.log('✅ Database already has data')
        }

        setIsInitializing(false)
      } catch (err) {
        console.error('❌ Database initialization failed:', err)
        setError(err instanceof Error ? err.message : 'Failed to initialize database')
        setIsInitializing(false)
      }
    }

    initializeDatabase()
  }, [])

  if (isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Initializing Database</h2>
          <p className="text-gray-500">Setting up your training system...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md mx-auto p-6">
          <div className="text-red-500 text-6xl mb-4">⚠️</div>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Database Error</h2>
          <p className="text-gray-500 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Retry
          </button>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
